import { render } from "./DynamicQuizResource.vue?vue&type=template&id=bf879b00&scoped=true"
import script from "./DynamicQuizResource.vue?vue&type=script&lang=js"
export * from "./DynamicQuizResource.vue?vue&type=script&lang=js"

import "./DynamicQuizResource.vue?vue&type=style&index=0&id=bf879b00&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-bf879b00"

export default script